import Shipment from "../views/Shipment";

export default {
  strict: false,
  namespaced: true,
  state: () => ({
    resentTabs: []
  }),
  mutations: {
    SET_RESENT_TABS(state, tabs) {
      state.resentTabs = tabs;
    }
  },
  actions: {
    ADD_RESENT_TAB({ commit, state }, view_item) {
      let tab = {};
      if (view_item.shipment_id) {
        tab.shipment_id = view_item.shipment_id;
        if (parseInt(tab.shipment_id) === 0) {
          tab.text = "New Lead";
          tab.link = "/shipment/0";

          if (
            !state.resentTabs.some(resentTab => resentTab.link === tab.link)
          ) {
            commit("SET_RESENT_TABS", {
              ...state.resentTabs,
              tab
            });
          }
        } else {
          tab.text =
            "#" +
            view_item.shipment_id +
            " " +
            view_item.first_name +
            " " +
            view_item.last_name;
          tab.link = "/shipment/" + view_item.shipment_id;
          this.$root.newShipmentTab = tab;
        }

        this.$router.addRoutes([
          {
            path: "/shipment/:id",
            component: Shipment,
            name: "shipment_" + tab.shipment_id,
            props: true
          }
        ]);
        this.$router.push({
          // path: tab.link,
          params: { id: tab.shipment_id },
          name: "shipment_" + tab.shipment_id
          // props: true,
        });
      } else {
        tab.text = view_item.text;
        tab.link = view_item.link;
      }

      tab.show = true;
      const isTabExist = state.resentTabs.some(
        resentTab => resentTab.link === tab.link
      );
      if (
        !isTabExist &&
        !view_item.shipment_id &&
        view_item.shipment_id != "0"
      ) {
        commit("SET_RESENT_TABS", {
          ...state.resentTabs,
          tab
        });
      }
    }
  },
  getters: {
    GET_TABS: state => {
      return state.resentTabs;
    }
  }
};
